import React from "react";
import { Navbar } from "react-bootstrap";
function HeaderDashboardLogin() {
  return (
    <Navbar expand="lg" className="bg-body-tertiary header">

      <Navbar.Brand href="/dashboard">
        <img src="/images/logo.png" alt="Logo" height="32"/>
      </Navbar.Brand>

    </Navbar>
  );
}

export default HeaderDashboardLogin;
